import React from 'react';
import PropTypes from 'prop-types';

const FormButtons = ({ onSave, onCancel, disabled }) => (
  <div className="button-container">
    <button
      type="button"
      className="save-button"
      onClick={() => onSave()}
      disabled={disabled}
    >
      save
    </button>
    <button
      type="button"
      className="cancel-button"
      onClick={() => onCancel()}
    >
      cancel
    </button>
  </div>
);

FormButtons.defaultProps = {
  onSave: () => null,
  onCancel: () => null,
  disabled: false,
};

FormButtons.propTypes = {
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  disabled: PropTypes.bool,
};

export default FormButtons;
